import { render, staticRenderFns } from "./LoadingPadrao.vue?vue&type=template&id=caafbbf6&scoped=true&"
import script from "./LoadingPadrao.vue?vue&type=script&lang=js&"
export * from "./LoadingPadrao.vue?vue&type=script&lang=js&"
import style0 from "./LoadingPadrao.vue?vue&type=style&index=0&id=caafbbf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caafbbf6",
  null
  
)

export default component.exports